import { AxiosInstance, AxiosResponse } from 'axios';
import { Query, toAxiosQuery } from '@shared/models/Query';
import toMock from '@shared/api/toMock';

export function sendAxios<ResponseType>(args: {
  axios: AxiosInstance;
  path: string;
  query: Query;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
  method: string;
  mock_response?: ResponseType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}): Promise<AxiosResponse<ResponseType, any>> {
  const { axios, path, query, form, method, mock_response } = args;
  const axios_query = toAxiosQuery(query);

  const all_path = getAPIPath(path, !!mock_response);

  // mock_responseを指定している場合はその値を返却する
  if (mock_response) {
    toMock(axios, path, axios_query, method, mock_response);
  }

  if (method === 'post') {
    return axios.post(all_path, form).then((res: AxiosResponse<ResponseType>) => res);
  } else if (method === 'put') {
    return axios.put(all_path, form).then((res: AxiosResponse<ResponseType>) => res);
  } else if (method === 'delete') {
    return axios.delete(all_path, axios_query).then((res: AxiosResponse<ResponseType>) => res);
  }
  return axios.get(all_path, axios_query).then((res: AxiosResponse<ResponseType>) => res);
}

const getAPIPath = (path: string, use_mock: boolean) => {
  let all_path = '';
  const env_name = import.meta.env.VITE_ENV_NAME;
  if (use_mock) {
    all_path = path;
  } else if (process.env.NODE_ENV !== 'production') {
    all_path = `http://localhost:8000/api/${path}`;
  } else if (env_name === 'prod') {
    all_path = `https://api.demogrid.i-dea.ai/api/${path}`;
  } else {
    all_path = `https://api.${env_name}.dev-demogrid.i-dea.ai/api/${path}`;
  }
  return all_path;
};
